import { getAngleByThreePoint } from "@/src/utils/tryon/math";
import { CSSProperties } from "react";
// 默认pd
export const defaultPd = "63";
/**
 * 根据用户上传图片、眼镜图片、瞳孔位置、瞳距，输出眼镜的位置信息（样式信息）
 * @param leftEyeX 左眼的横坐标
 * @param leftEyeY 左眼的纵坐标
 * @param rightEyeX 右边的横坐标
 * @param rightEyeY 右眼的纵坐标
 * @param userUploadImgW 用户上传图片的宽
 * @param userUploadImgH 用户上传图片的高
 * @param glassesW 眼镜图片宽
 * @param glassesH 眼镜图片高
 * @param userPd 用户的pd
 * @param lt 如果用户上传的图片太高或者太宽，需要有偏移量来让图片显示正常
 */
export function wearGlasses(
    leftEyeX: number,
    leftEyeY: number,
    rightEyeX: number,
    rightEyeY: number,
    userUploadImgW: number,
    userUploadImgH: number,
    glassesW: number,
    glassesH: number,
    userPd: number,
    defaultPd: string,
    lt: number[],
): CSSProperties {
    /*
      第一步。把眼镜缩放到合适的程度
      计算步骤：
        1、计算图片中两个瞳孔的距离（瞳距）
        2、根据他们之前的比例，计算出眼镜的宽和高
    */
    const userUploadImgPd = Math.sqrt(
        Math.pow(rightEyeX - leftEyeX, 2) + Math.pow(rightEyeY - leftEyeY, 2),
    );
    // 眼镜图片宽度暂定为图片中瞳距*2  测试加上鼻梁的宽度
    const finalWidth = userUploadImgPd * 2 * 1.09;
    // 根据眼镜图片原来的宽高比例计算出眼镜图片高度
    const finalHeight = (finalWidth * glassesH) / glassesW;
    /*
      第二步。根据瞳孔坐标。计算眼镜图片的样式
      现在假设眼镜是平行的。那么眼镜的样式就是
      眼镜的位置根据两眼中间点进行定位。
      -------------------------------
      |                              |
      |     眼                 眼     |
      |     ---------pd---------     |
      |                              |
      -------------------------------
      所以眼镜的left就是 中间点横坐标 - （眼镜宽度-用户上传图片pd）/2
      top就是 中间点纵坐标 - 眼镜高度的28%。  本来应该是50%，但是经过测试发现50%就太靠上了，需要下移一些，最后暂定为28%。
    */
    const glassesImgLeft = leftEyeX - (finalWidth - userUploadImgPd) / 2;
    const glassesImgTop = (leftEyeY + rightEyeY) / 2 - finalHeight / 2;
    // 还需要根据左右眼和水平线的夹角对图片进行一个旋转（如果图片水平，那么就不需要对图片进行旋转了）

    // pointx 右眼横坐标-10，右眼横坐标，左眼横坐标。 -10是随便取右眼的水平线上的一个点的横坐标
    // pointy 右眼纵坐标，右眼纵坐标，左眼纵坐标
    // 得到两眼坐标确定的直线 和 水平线的夹角
    const angle = getAngleByThreePoint(
        [rightEyeX - 10, rightEyeX, leftEyeX],
        [rightEyeY, rightEyeY, leftEyeY],
    );

    const scale = Number(defaultPd) / userPd;

    return {
        width: finalWidth + "px",
        height: finalHeight + "px",
        left: glassesImgLeft + lt[0] + "px",
        // todo 不能这么做。在眼睛只要不是完全水平的情况下，就会有偏移，那么就会明显看到戴偏了。 如果要做，还需要测试。也许需要根据眼睛和水平线夹角来计算偏移量。
        // // 如果右眼高，眼镜往右移。如果左眼高，眼镜往左移。
        // left:
        //   (glassesImgLeft + lt[0]) *
        //     (leftEyeY < rightEyeY ? 0.967534 : 1.032466) +
        //   'px',
        // 眼镜向下带一些，会更自然一些
        top: glassesImgTop + lt[1] + finalHeight * 0.05 + "px",
        transform: `rotate(${
            leftEyeY > rightEyeY ? -angle : angle
        }deg) scale(${scale})`,
        position: "absolute",
        display: "block",
    };
}

// 选择pd的选项中，有些不是数字，返回默认pd
export function processInputPd(input: string) {
    if (input === "" + Number.MIN_VALUE) {
        input = defaultPd;
    }
    return input;
}
